export class ConceptDrug {
    Concept = null;
}
